export default "/assets/website/images/marker.png?14da1626c29c67e3d278eb2b9054bbdd";